<template>
  <div class="schedule-new-report container-fluid"> 
    <div id="myNav" class="overlay overlay-overall-width-100Perc">
      <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
        <div class="row margin-left-1Point6Perc">
          <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc create-element-overlay-course-title-font-styles">
            New Report
          </div>    
          <div class="col-md-5 col-lg-5">
            <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="closeCurrentPopUp(null)">
              <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
            </div>  
          </div>
        </div>
        <div class="row margin-left-1Point5Perc padding-bottom-1Perc bottom-border margin-bottom-2Perc">
          <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
            Schedule Report
          </div>    
        </div>
        <div class="row vertical-align margin-bottom-3Perc">
          <div class="col-md-1 col-lg-1">
          </div>  
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Author
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="text" class="form-control" v-model="getScheduleReportAuthor" :maxlength="maxLength">
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Frequency
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <select class="form-control" v-model="getScheduleReportFrequency">
                  <option :value=constants.ReportingTaskFrequency.None disabled>Select</option>
                  <option :value=constants.ReportingTaskFrequency.Immediate>Immediate</option>
                  <option :value=constants.ReportingTaskFrequency.Daily>Daily</option>
                  <option :value=constants.ReportingTaskFrequency.Weekly>Weekly</option>
                  <option :value=constants.ReportingTaskFrequency.Monthly>Monthly</option>
              </select>                  
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>
        </div>

        <div class="row vertical-align margin-bottom-3Perc" v-if="getScheduleReportFrequency !== constants.ReportingTaskFrequency.Immediate">
          <div class="col-md-1 col-lg-1">
          </div>  
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Start Time
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <date-picker v-model="getScheduleReportStartTS" :config="startDateConfig"></date-picker>
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            End Time
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <date-picker v-model="getScheduleReportEndTS" :config="endDateConfig"></date-picker>
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1"></div>
        </div>

        <div class="row vertical-align margin-bottom-3Perc">
          <div class="col-md-1 col-lg-1">
          </div>  
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            To Email(s)
          </div>
          <div class="col-md-9 col-lg-9">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="text" class="form-control" v-model="getScheduleReportToEmails">
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1 padding-left-0px text-align-left">
            <div class="tooltip1">
              <img :src="iconInfo" alt="iconCopy" class="height-20Px width-20Px img-opacity cursor-pointer">
              <span class="tooltiptext1">{{constants.To_Email_Tooltip}}</span> 
            </div>
          </div>
        </div>

        <div class="row vertical-align margin-bottom-2Perc">
          <div class="col-md-1 col-lg-1">
          </div>  
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Content
          </div>
          <div class="col-md-9 col-lg-9">
            <div class="form-group">
              <div class="col-sm-12">
                <tinymce id="d1" v-model="getScheduleReportDesc"></tinymce>
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>  
        </div>

        <div class="row margin-bottom-2Perc">
          <div class="col-md-5 col-lg-5">
          </div>  
          <div class="col-md-2 col-lg-2">
            <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="scheduleNewReport">Schedule</button>
          </div>  
          <div class="col-md-5 col-lg-5">
          </div>
        </div>
        <div class="row"></div>         
      </div>
    </div>
    <loader></loader>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  </div> 
</template>
<script>
import iconInfo from '../../assets/images/iconinfoblue.png'
import { constants } from '@/utils/constants'
import { VueEditor } from 'vue2-quill-editor'
import { newReportService } from '@/server-util/new-report-service'
import AlertBox from '@/components/AlertOverlay'
import tinymce from 'vue-tinymce-editor'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import moment from 'moment'
import Loader from '@/components/dashboard/Loader'
import datePicker from 'vue-bootstrap-datetimepicker'
import forEach from 'lodash/forEach'
export default {
  props: ['gccDataObj', 'selectedReportsForProcessing'],
  name: 'schedule-new-report',
  created () {
    this.setDefaultValues()
  },
  data: function () {
    var currentTS = moment().tz('America/New_York').format('MM/DD/YYYY hh:mm:ss A')
    var endTS = moment().tz('America/New_York').add(1, 'days').format('MM/DD/YYYY hh:mm:ss A')
    return {
      iconInfo: iconInfo,
      constants: constants,
      maxLength: constants.Element_Title_Step_Max_Length,
      showAlertDialog: false,
      errorMsg: '',
      startDateConfig: {
        format: 'MM/DD/YYYY hh:mm:ss A',
        useCurrent: true,
        sideBySide: true,
        minDate: currentTS
      },
      endDateConfig: {
        format: 'MM/DD/YYYY hh:mm:ss A',
        useCurrent: true,
        sideBySide: true,
        minDate: currentTS
      },
      scheduleReportObj: {
        Frequency: constants.ReportingTaskFrequency.None,
        ReportTypes: '',
        Description: '',
        Author: '',
        StartTS: currentTS,
        EndTS: endTS,
        ToEmails: '',
        GroupData: {}
      },
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block', 'image', 'video', 'formula', {'color': []}, {'background': []}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'align': []}, 'link'],
        [{'header': [1, 2, 3, 4, 5, 6, false]}, {'font': []}],
        [{'script': 'sub'}, {'script': 'super'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        [{ 'direction': 'rtl' }],
        ['clean']
      ]
    }
  },
  components: {
    'alert-box': AlertBox,
    VueEditor,
    'tinymce': tinymce,
    'date-picker': datePicker,
    'loader': Loader
  },
  methods: {
    validateEmail: function () {
      var invalidEmailAddressArr = []
      /* eslint-disable */
      var mailformat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      /* eslint-enable */
      var commaSeparatedEmailIds = this.getScheduleReportToEmails.split(',')
      console.log('commaSeparatedEmailIds: ' + JSON.stringify(commaSeparatedEmailIds))
      forEach(commaSeparatedEmailIds, (currEmailId) => {
        if (!mailformat.test(currEmailId.trim())) {
          invalidEmailAddressArr.push(currEmailId)
        }
      })
      console.log('invalidEmailAddressArr: ' + invalidEmailAddressArr.join(','))
      return invalidEmailAddressArr.length > 0 ? invalidEmailAddressArr.join(',') : ''
    },
    closeCurrentPopUp: function (createdObj) {
      var objToReturn = {
        operationName: 'close_overlay',
        comingFrom: 'create',
        obj: createdObj
      }
      this.$emit('closeOverlay', objToReturn)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },
    scheduleNewReport: function (event) {
      // alert(JSON.stringify(this.elementObj))
      if (this.validateRequiredFieldBeforeSubmit()) {
        var storeObj = this.$store
        if (
          this.scheduleReportObj !== undefined &&
          this.scheduleReportObj !== null &&
          this.scheduleReportObj !== 'undefined' &&
          this.scheduleReportObj !== 'null'
        ) {
          this.$store.state.isLoading = true
          const orgContent = dmAdminUtils.removeTFromUrls(this.getScheduleReportDesc)
          this.getScheduleReportDesc = orgContent
          newReportService
            .scheduleNewReport(storeObj.state.access_token, this.scheduleReportObj)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.$store.state.isLoading = false
                this.closeCurrentPopUp(responseObj.data)
              } else {
                // AK: Hide Spinner
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Selected Schedule Report object is NULL hence declined CREATE OPERATION'
          )
        }
      }
    },
    setDefaultValues: function () {
      this.scheduleReportObj.GroupData = this.gccDataObj
      var selectedReportEnumArr = []
      forEach(this.selectedReportsForProcessing, (currObj) => {
        selectedReportEnumArr.push(currObj.selectedReportEnum)
      })
      this.scheduleReportObj.ReportTypes = selectedReportEnumArr.join(',')
      var currentDate = moment().tz('America/New_York').add(0, 'days').format('MM/DD/YYYY hh:mm:ss A')
      this.scheduleReportObj.StartTS = currentDate
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.getScheduleReportAuthor.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Author can\'t be empty.'
        return false
      } else if (this.getScheduleReportFrequency === constants.ReportingTaskFrequency.None) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a email frequency.'
        return false
      } else if (this.getScheduleReportStartTS === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a start time.'
        return
      } else if (this.getScheduleReportEndTS === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select an end time.'
        return
      } else if (Date.parse(this.getScheduleReportStartTS) > Date.parse(this.getScheduleReportEndTS)) {
        this.showAlertDialog = true
        this.errorMsg = 'Start time must be less than the end time.'
        return
      } else if (this.getScheduleReportToEmails.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'To Email(s) can\'t be empty.'
        return false
      } else if (this.validateEmail().trim().length > 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Invalid email address found: ' + this.validateEmail()
        return false
      } else if (this.stripHtml(this.getScheduleReportDesc).length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Content can\'t be empty.'
        return false
      }
      return true
    }
  },
  computed: {
    getScheduleReportFrequency: {
      get: function () {
        return this.scheduleReportObj.Frequency
      },
      set: function (newValue) {
        this.scheduleReportObj.Frequency = newValue
      }
    },
    getScheduleReportDesc: {
      get: function () {
        return this.scheduleReportObj.Description
      },
      set: function (newValue) {
        this.scheduleReportObj.Description = newValue
      }
    },
    getScheduleReportAuthor: {
      get: function () {
        return this.scheduleReportObj.Author
      },
      set: function (newValue) {
        this.scheduleReportObj.Author = newValue
      }
    },
    getScheduleReportToEmails: {
      get: function () {
        return this.scheduleReportObj.ToEmails
      },
      set: function (newValue) {
        this.scheduleReportObj.ToEmails = newValue
      }
    },
    getScheduleReportStartTS: {
      get: function () {
        return this.scheduleReportObj.StartTS
      },
      set: function (newValue) {
        this.scheduleReportObj.StartTS = newValue
      }
    },
    getScheduleReportEndTS: {
      get: function () {
        return this.scheduleReportObj.EndTS
      },
      set: function (newValue) {
        this.scheduleReportObj.EndTS = newValue
      }
    }
  }
}
</script>

<style scoped>
.padding-left-0px {
  padding-left: 0px !important;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-left-1Point6Perc
{
  margin-left:1.6%;
}
.border-red {
  border: 1px solid red;
}
.margin-bottom-1Perc {
  margin-bottom: 1%;
}
.create-lesson-label-text-style {
  color: #34495e;
  font-size: 12px;
}
.margin-bottom-3Perc {
  margin-bottom: 3%;
}
.margin-bottom-2Perc {
  margin-bottom:2%;
}
.margin-left-0px {
  margin-left:0px;
}
.margin-bottom-4point5px {
  margin-bottom:4.5px;
}
.text-vertical-center {
  text-align: center;
}
.padding-16px-0px {
  padding:16px 0px;
}
.background-color {
  background-color: #eee;
}
.border-light-grey {
 border: 1px solid #d6d6d6;   
}
.tooltip1 {
    position: relative !important;
    display: inline-block !important;
    /* border-bottom: 1px dotted black !important; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    width: 90px;
    background-color: #696969;
    /* opacity:0.8; */
    color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 5px 5px;
    font-size: 12px;
    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    top: 107%;
    left: 35%;
    margin-left: -60px;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1:hover .tooltiptext1 {
    visibility: visible;
}
.height-20Px {
 height:20px; 
}
.width-20Px {
  width:20px;
}
</style>


// WEBPACK FOOTER //
// src/components/new_report/ScheduleNewReport.vue